import React, { useState, useRef } from "react";
import axios from "axios";
import { useAuth } from "../../context/AuthContext";

const CargaProgramaSorteo = () => {
  const auth = useAuth();
  const userRole = auth.role || null;

  const [imagen, setImagen] = useState(null);
  const [imagenBase64, setImagenBase64] = useState("");
  const [programa, setPrograma] = useState("");
  const [mes, setMes] = useState("");
  const [anio, setAnio] = useState("");
  const [mensaje, setMensaje] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  // 👉 referencia al input de imagen
  const inputFileRef = useRef();

  const programas = [
    "Previa",
    "Primera",
    "Matutina",
    "Vespertina",
    "Nocturna",
    "Quini 6",
    "Brinco",
    "Lotería",
    "Loto 5",
    "Loto Plus",
    "Pozo de la Quiniela",
    "Tombo Express",
    "Telekino",
    "Betwarrior"
  ];

  const handleImagenChange = (e) => {
    const file = e.target.files[0];
    setImagen(file);

    const reader = new FileReader();
    reader.onloadend = () => {
      const base64String = reader.result.split(",")[1];
      setImagenBase64(base64String);
    };
    reader.readAsDataURL(file);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!imagenBase64 || !programa || !mes || !anio) {
      setMensaje("Por favor completa todos los campos.");
      return;
    }

    const mesAnio = `${anio}-${mes.padStart(2, "0")}`;
    setIsSubmitting(true);
    setMensaje("");

    try {
      const { data } = await axios.post(
        "https://us-central1-inprojuy-f1173.cloudfunctions.net/app/api/programas-sorteos",
        {
          imagenBase64,
          programa,
          mesAnio,
        }
      );

      setMensaje(`Carga exitosa. Imagen URL: ${data.urlImagen}`);

      // Resetear campos
      setImagen(null);
      setImagenBase64("");
      setPrograma("");
      setMes("");
      setAnio("");

      // Limpiar el input file
      if (inputFileRef.current) {
        inputFileRef.current.value = "";
      }
    } catch (error) {
      console.error("Error al subir:", error);
      const resData = error.response?.data;
      const msg =
        typeof resData === "string"
          ? resData
          : resData?.message || resData?.error || error.message;
      setMensaje(`Error: ${msg}`);
    } finally {
      setIsSubmitting(false);
    }
  };

  if (userRole !== "admin") {
    return (
      <div className="container mt-5">
        <center>
          <h2 className="text-danger">Acceso no autorizado</h2>
          <p>No tiene permisos para acceder a esta página.</p>
        </center>
      </div>
    );
  }

  return (
    <div className="container mt-4">
      <h2>Cargar Programa Sorteo</h2>
      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label>Imagen:</label>
          <input
            type="file"
            accept="image/*"
            className="form-control"
            onChange={handleImagenChange}
            ref={inputFileRef} // asignar ref
          />
        </div>

        <div className="mb-3">
          <label>Programa:</label>
          <select
            className="form-select"
            value={programa}
            onChange={(e) => setPrograma(e.target.value)}
          >
            <option value="">-- Seleccionar --</option>
            {programas.map((p) => (
              <option key={p} value={p}>
                {p}
              </option>
            ))}
          </select>
        </div>

        <div className="mb-3">
          <label>Mes:</label>
          <select
            className="form-select"
            value={mes}
            onChange={(e) => setMes(e.target.value)}
          >
            <option value="">-- Mes --</option>
            {Array.from({ length: 12 }, (_, i) => (
              <option key={i + 1} value={(i + 1).toString()}>
                {i + 1}
              </option>
            ))}
          </select>
        </div>

        <div className="mb-3">
  <label>Año:</label>
  <select
    className="form-select"
    value={anio}
    onChange={(e) => setAnio(e.target.value)}
  >
    <option value="">-- Año --</option>
    {Array.from({ length: 6 }, (_, i) => {
      const year = 2025 + i;
      return (
        <option key={year} value={year}>
          {year}
        </option>
      );
    })}
  </select>
</div>

        <button
          type="submit"
          className="btn btn-primary"
          disabled={isSubmitting}
        >
          {isSubmitting ? "Subiendo..." : "Subir"}
        </button>
      </form>
      {mensaje && <div className="mt-3 alert alert-info">{mensaje}</div>}
    </div>
  );
};

export default CargaProgramaSorteo;
